import type { Vertex } from '@phi/jcore';
import { is_vertex_clipped, section_planes_active } from '@features/clipping';
import app from '@frontend/application-container';
import { mustNotDisplayVertex } from '@frontend/lattice';
import { vertex_is_for_sketch } from '@frontend/reference_sketches';
import { force_refresh } from '@frontend/state/force-refresh';
import { uid_deselect_all_objects } from '@frontend/ui_display';
import { uil_is_object_visible } from '@frontend/ui_logic';
import { ref, computed } from 'vue';

export const indicated_vertices = ref([] as Array<Vertex>);

export const filtered_indicated_vertices = computed(() => indicated_vertices.value.filter(x =>
    uil_is_object_visible(x)
    && !mustNotDisplayVertex(x)
    && (!vertex_is_for_sketch(x) || (
        app.state.editing_reference_sketches
        || app.state.showing_reference_sketches
    ))
    && (!section_planes_active() || !is_vertex_clipped(x))
));

export function hide_indicated_vertices() {
    indicated_vertices.value = [];
}

export function indicate_vertices(xs: Vertex[]) {
    indicated_vertices.value = xs ?? [];
    force_refresh();
}

export function indicate_selected_vertices(xs: Vertex[]) {
    if (selected_coordinates_visible.value)
        indicate_vertices(xs);
}

export function indicate_moving_vertices(xs: Vertex[]) {
    if (moving_coordinates_visible.value)
        indicate_vertices(xs);
}

export const moving_coordinates_visible = ref(false);

export function make_moving_coordinates_invisible() {
    moving_coordinates_visible.value = false;
    hide_indicated_vertices();
}

export function make_moving_coordinates_visible() {
    moving_coordinates_visible.value = true;
}

export const selected_coordinates_visible = ref(false);

export function make_selected_coordinates_invisible() {
    selected_coordinates_visible.value = false;
    hide_indicated_vertices();
}

export function make_selected_coordinates_visible() {
    selected_coordinates_visible.value = true;
    indicate_vertices(
        uid_selected_vertices.keys().length > 0
            ? uid_selected_vertices.keys()
            : uid_vertices.keys()
    );
    uid_deselect_all_objects();
}
